<template>
  <div v-if="timeSlots.length > 0" class="resource-timeslots-item mx-3 mb-3">
    <resource-conflict v-for="timeSlot in timeSlots"
      :key="timeSlot.id"
      :resource-id="resource.id"
      :time-slot="timeSlot"
      v-model="slotStatus[timeSlot.id]"/>
    <div class="resource-card mx-1 mb-3" :class="{ 'resource-card--unavailable': !isAvailable }">
      <div class="resource-card_header d-flex align-items-center justify-content-between">
        <span class="resource-card_name">{{ resource.name }}</span>
        <div class="d-flex align-items-center">
          <span class="availability-dot" :class="{ 'availability-dot--unavailable': !isAvailable }"></span>
          <span class="availability-label" :class="{ 'availability-label--unavailable': !isAvailable }">
            {{ isAvailable ? 'Available' : 'Unavailable' }}
          </span>
        </div>
      </div>
      <div class="resource-card_body d-flex flex-wrap justify-content-center">
        <template v-if="isAvailable">
          <div v-for="timeSlot in availableTimeSlots"
            :key="timeSlot.id"
            class="timeslots-item_btn"
            :class="{ 'active': isSelected(timeSlot) }"
            @click="selectTimeSlot(timeSlot)">
            {{ formatTime(timeSlot.startTime) }}
          </div>
        </template>
        <span v-else class="unavailable-message">No times available</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { mapState, mapMutations } from 'vuex'
import { TimeFormatMixin } from '@/mixins/Booking/TimeFormatMixin'
import ResourceConflict from '@/components/Booking/ResourceConflict/ResourceConflict.vue'

export default {
  name: 'ResourceTimeSlotsItem',
  mixins: [TimeFormatMixin],
  props: {
    resource: Object,
    timeSlots: Array
  },
  data () {
    return {
      slotStatus: {}
    }
  },
  computed: {
    ...mapState('BookingUpload', [
      'startUtc',
      'resourceIds'
    ]),
    availableTimeSlots () {
      return this.timeSlots.filter(ts => {
        const status = this.slotStatus[ts.id]
        return status ? status.available : false
      })
    },
    isAvailable () {
      return this.availableTimeSlots.length > 0
    }
  },
  watch: {
    slotStatus: {
      deep: true,
      handler (status) {
        if (Object.keys(status).length === this.timeSlots.length) {
          this.$emit('available-count-change', { resourceId: this.resource.id, count: this.availableTimeSlots.length })
        }
      }
    }
  },
  methods: {
    ...mapMutations('BookingUpload', [
      'setResourceIds',
      'setStartUtc'
    ]),
    isSelected (timeSlot) {
      const slotUtc = moment(timeSlot.startTime).utc().format()
      return this.startUtc === slotUtc && this.resourceIds.includes(this.resource.id)
    },
    formatTime (startTime) {
      return moment(startTime).format(this.momentJSTimeFormat)
    },
    selectTimeSlot (timeSlot) {
      this.setResourceIds([this.resource.id])
      this.setStartUtc(moment(timeSlot.startTime).utc().format())
    }
  },
  components: {
    'resource-conflict': ResourceConflict
  }
}
</script>

<style scoped>
.resource-card {
  border: 1px solid #e0e0e0;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.resource-card_header {
  padding: 0.625rem 1rem;
  border-bottom: 1px solid #e0e0e0;
  background-color: #fafafa;
}

.resource-card_name {
  font-weight: 600;
}

.availability-dot {
  display: inline-block;
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  background-color: #28a745;
  margin-right: 0.375rem;
}

.availability-dot--unavailable {
  background-color: #dc3545;
}

.availability-label {
  font-size: 0.8rem;
  color: #28a745;
  font-weight: 500;
}

.availability-label--unavailable {
  color: #dc3545;
}

.resource-card--unavailable {
  opacity: 0.6;
}

.unavailable-message {
  font-size: 0.85rem;
  color: #6c757d;
  padding: 0.25rem 0;
}

.resource-card_body {
  padding: 0.75rem;
}
</style>
